import React, { useEffect, useState } from "react";
import {
  colorBlack,
  colorDarkBlue,
  colorWhite,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import { CustomButton } from "../../../components/main_comps/custom_button";
import MainComponent from "../../../components/ui_comps/MainComponent";
import { AiOutlinePlus } from "react-icons/ai";
import CustomModal from "../../../components/main_comps/custom_modal";
import OnboardUserIndex from "./onboard_user/index";
import CustomTable from "../../../components/main_comps/custom_table";
import {
  TransactionHeaders,
  UserListHeaders,
} from "../../../../utility/TableHeaders";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllUserList } from "../../../../services/fetchListingData";
import {
  ROLE_ADD_ACL,
  ROLE_ViewMore_ACL,
  STATUS_CODE_200,
  STATUS_OK,
} from "../../../../utility/constants/valueConstants";
import { useNavigate } from "react-router";
import { useSnackbar } from "notistack";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { CgLaptop } from "react-icons/cg";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
function RoleManagementIndex() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [onclickAddUser, setOnClickAddUser] = useState(false);
  const [statusConfirm, setStatusConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roleData, setRoleData] = useState({});
  const userList = useSelector((state) => state.listingSlice.userList);
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const changeStatus = (userId, status) => {
    ApiRequestPost.updateAdminStatus({
      userId,
      status,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          setStatusConfirm(false);
          dispatch(fetchAllUserList(1, 10));
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    dispatch(fetchAllUserList(1, 10));
  }, []);
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {}}
        onClickFilterCall={() => {}}
        headerTitle="Role Management"
        customButtonRequired={
          aclData.includes(ROLE_ADD_ACL) ? (
            <CustomButton
              title={"Add user"}
              styles={{
                backgroundColor: colorDarkBlue,
                border: "none",
                marginLeft: 30,
              }}
              onClick={() => {
                setOnClickAddUser(true);
              }}
              icon={<AiOutlinePlus color="white" />}
            ></CustomButton>
          ) : null
        }
        filterRequired={false}
      />
      <div style={{ padding: "0px 10px", overflow: "hidden" }}>
        <CustomTable
          data={userList.users}
          headers={setHeaders(UserListHeaders, aclData)}
          totalElements={userList.totalRecords}
          totalPages={userList.totalPages}
          handlePaginate={(page) => {
            dispatch(fetchAllUserList(page + 1, 10));
          }}
          onViewMore={(data) => {
            if (aclData.includes(ROLE_ViewMore_ACL)) {
              navigate("/role-management/details", {
                state: { data },
              });
            }
          }}
          currentPage={userList?.currentPageNo - 1}
          onStatusChange={(data) => {
            setStatusConfirm(true);
            setRoleData(data);
            // changeStatus(data?.userId, !data?.status);
          }}
        />
      </div>
      {onclickAddUser && (
        <CustomModal
          headerTitle="Add user"
          open={onclickAddUser}
          onClose={() => {
            setOnClickAddUser(false);
          }}
          containerStyle={{
            width: "auto",
            height: "auto ",
          }}
        >
          <OnboardUserIndex
            onClose={() => {
              setOnClickAddUser(false);
            }}
          />
        </CustomModal>
      )}
      {statusConfirm && (
        <CustomModal
          headerTitle=""
          open={statusConfirm}
          onClose={() => {
            setStatusConfirm(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <div
            style={{
              color: primaryColor,
              fontWeight: "500",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            {`Do you want to ${roleData.status ? "disable" : "enable"}
     ${roleData?.firstName} ${roleData?.lastName}?`}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <CustomButton
              title="Cancel"
              styles={{
                backgroundColor: colorWhite,
                border: "1px solid black",
                padding: 0,
                height: "auto",
                padding: "13px 10px",
                margin: 10,
              }}
              textStyles={{
                color: colorBlack,
              }}
              onClick={() => setStatusConfirm(false)}
            />{" "}
            <CustomButton
              title="Yes"
              styles={{
                backgroundColor: primaryColor,
                border: "none",
                padding: 0,
                height: "auto",
                padding: "15px 40px",
                margin: 10,
              }}
              textStyles={{
                color: colorWhite,
              }}
              onClick={() => {
                changeStatus(roleData?.userId, !roleData?.status);
              }}
              disabled={false}
              loading={loading}
            />
          </div>
        </CustomModal>
      )}
    </div>
  );
}
export default RoleManagementIndex;
